import { render } from "./productDetail.vue?vue&type=template&id=b96ae076&ts=true"
import script from "./productDetail.vue?vue&type=script&lang=ts"
export * from "./productDetail.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__